module.exports = __webpack_public_path__ + "img/Plus.c0563101.svg";